import { useEffect, useRef } from 'react'
import { useQueryParam } from './useQueryParam'

export const DRAFT_FILTER = { is_draft: true }

/**
 * Adds the drafts filter from `?draft=1` without replacing other filters.
 * Clears the param with replace so a refresh does not re-apply it.
 */
export const useDraftFilterFromQuery = (
  filters: Array<Record<string, unknown>>,
  onFilter: (filters: Array<Record<string, unknown>>) => void
): void => {
  const [draftParam, setDraftParam] = useQueryParam<string>('draft')
  const consumedRef = useRef(false)
  const stateRef = useRef({ filters, onFilter })
  stateRef.current = { filters, onFilter }

  useEffect(() => {
    if (!draftParam) {
      consumedRef.current = false
      return
    }
    if (consumedRef.current) return

    consumedRef.current = true
    setDraftParam(undefined, { replace: true })

    const { filters: current, onFilter: apply } = stateRef.current
    if (current.some(filter => filter.is_draft === true)) return
    apply([...current, DRAFT_FILTER])
  }, [draftParam, setDraftParam])
}
